<script setup lang="ts">
/**
 * The bubble a scene opens on: the Copilote types, and its words land a
 * moment later.
 *
 * Every scene of the course opens this way, so the pair is held here rather
 * than written out in each one. The words are served — the handler of the
 * block composes them; when they land is the scene's pacing, which hands
 * over `shown`.
 *
 * The two bubbles are keyed apart so the words land on their own animation
 * rather than replacing the dots in place.
 */
import MedicationCheckupCopiloteLine from "@/medication-checkup/components/MedicationCheckupCopiloteLine.vue";

defineProps<{
    /**
     * Whether the words have landed. Until they have, the bubble types.
     */
    shown: boolean;
    text: string;
}>();
</script>

<template>
  <MedicationCheckupCopiloteLine
    v-if="!shown"
    key="typing"
    typing
    class="animate-message-in"
  />
  <MedicationCheckupCopiloteLine
    v-else
    key="bubble"
    :text="text"
    class="animate-message-in"
  />
</template>
